module.exports = __webpack_public_path__ + "img/th.6d504885.png";